import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

import Page from '@/components/prismic/Page';
import HomePage from '@/views/HomePage';
import Reports from '@/views/reports/Reports';
import Report from '@/views/reports/Report';
import SignupPage from '@/views/Signup';
import Contact from '@/views/contact/Contact';

import NotFound from '@/components/NotFound';
import ServerError from '@/components/ServerError';
import Preview from '@/components/prismic/Preview';

Vue.use(Router);
Vue.use(Meta);

const routes = [
  {
    path: '/',
    component: HomePage
  },
  {
    path: '/test-kit',
    component: Page
  },
  {
    path: '/app',
    component: Page
  },
  {
    path: '/web-test',
    component: Page
  },
  {
    path: '/reports',
    component: Reports
  },
  {
    path: '/reports/:title',
    component: Report
  },
  {
    path: '/contact',
    component: Contact
  },
  {
    path: '/signup',
    component: SignupPage
  },
  {
    path: '/eula',
    component: Page
  },
  {
    path: '/privacy-policy',
    component: Page
  },
  {
    path: '/terms-and-conditions',
    component: Page
  },
  {
    path: '/cookie-policy',
    component: Page
  },
  {
    path: '/404',
    component: NotFound
  },
  {
    path: '/500',
    component: ServerError
  },
  {
    path: '/preview',
    component: Preview
  },
  {
    path: '*',
    component: NotFound
  },
  {
    path: '/faqs',
    component: Page
  }
  // Redirects
  //  Should copy redirects from meqyas.sa - master and create new redirects if needed
];

export default function createRouter() {
  const router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior: to => {
      if (to.hash) {
        return { selector: to.hash };
      }
      return { x: 0, y: 0 };
    }
  });

  router.afterEach(to => {
    if (typeof window === 'undefined') {
      return;
    }

    if (window.ga) {
      window.ga('set', 'page', to.path);
      window.ga('send', 'pageview');
    }
  });

  return router;
}
